import { Inject, Component, Input, Output, EventEmitter, OnInit, OnDestroy} from '@angular/core';
import { FactoryService } from '@services/common/factory.service';
import { TrackingInterface, SH_TRACKING} from '@libs/tracking';
import { AcpService } from '@services/common/acp.service';

@Component({
  standalone: false,
  selector: 'com-pop',
  templateUrl: './com-pop.component.html',
  styleUrls: ['./com-pop.component.scss']
})
export class ComPopComponent implements OnInit,OnDestroy{
  // @Input() type: string; //control popup type ( forgetPwd/common )
  @Input() popTitle: string = 'Profile.Common.Txt.Reminder'; //default title 'Reminder'
  @Input() innerFlag = false; //control description use innerHtml
  @Input() popDesc: string;
  @Input() descPip: boolean = true; // control use pip for desc or not
  @Input() showBtn = true; //control show button
  @Input() showBtn3 = false; //control show the third button
  @Input() popBtn1: string = 'Profile.Common.Btn.Confirm'; // first btn in popup
  @Input() popBtn2: string; //second btn in popup
  @Input() popBtn3: string = 'Profile.Common.Btn.Cancel'; //third btn in popup
  @Input() showClose = true; // control close icon
  @Input() popKey: string; //use for check which popup (forgetPwd | deleteAcct | logout)

  @Output() btnActionEmit = new EventEmitter<string>();

  constructor(
    public factorySer: FactoryService,
    private acpSer: AcpService,
    @Inject(SH_TRACKING) private trackIn: TrackingInterface
  ) { }

  ngOnInit() { 
    if (this.popKey) { 
      this.setTrack('popup_view');
    }
    this.elementNotScroll(true);
  }

  ngOnDestroy(): void {
    this.elementNotScroll(false);
  }

  // 打开弹窗后，禁止遮罩层下方元素滚动
  elementNotScroll(open: boolean) {
    document.body.style.overflow = open ? 'hidden': 'auto';
  }

  /* diff btn will have diff value, and will check diff function or business
    01: click the first btn (forget popup is phone-verify)
    02: click the second btn (forget popup is email-verify)
    03: click the third btn
  */
  public gotoNext(value: string) { 
    if (this.popKey) { 
      this.setTrack('popup_click', value);
    }
    switch (value) {
      case '01':
        this.btnActionEmit.emit(this.popKey === 'forgetPwd'? 'phoneVerify': '01');
        break;
      case '02':
        this.btnActionEmit.emit(this.popKey === 'forgetPwd'? 'emailVerify': '02');
        break;
      default:
        this.btnActionEmit.emit(value);
        break;
    }
  }

  async setTrack(event: string, btnKey?: any) {
    let params = {};
    if (btnKey) { 
      params['cta_name'] = this.getCtaName(btnKey);
    }
    this.trackIn.setTracking({
      event,
      screen_type: this.getScreenType(),
      page_name: this.getPageName(),
      popup_name: this.getPopName(),
      popup_text: (this.innerFlag || this.descPip)? this.acpSer.getAcpText(this.popDesc) : this.popDesc,
      ...params
    });
  }

  private getScreenType(): string { 
    switch (this.popKey) {
      case 'deleteAcct':
      case 'logout':
        return 'edit_profile';
      case 'forgetPwd':
        const logined = this.factorySer.getLoginStatus();
        return logined ? 'edit_profile' : 'login';
      default:
        return null;
    }
  }

  /* default popKey is 'logout'
    1. delete popup:
      01 is first confirm btn in popup 
    2. logout popup: 
      01 is the first 'confirm' btn in popup
      02 is the seconds 'change phone' btn in popup
    3. forget passwd:
      01 use 'phone to verify' btn
      02 use 'email to verify' btn
  */
  private getCtaName(key?: string): string { 
    switch (this.popKey) {
      case 'deleteAcct':
        return key === '01' ? 'delete' : 'not_delete';
      case 'forgetPwd':
        return key === '01' ? 'phone' : (key === '02' ? 'email' : 'cancel');
      default:
        return key === '01' ? 'confirm_sign_out' : (key == '02' ? 'update_mobile_number' : 'cancel');
    }
  }

  //default popKey is 'logout'
  private getPageName(): string {
    switch (this.popKey) {
      case 'deleteAcct':
        return 'tools/profile/verification_code';
      case 'forgetPwd':
        const logined = this.factorySer.getLoginStatus();
        return logined ? 'tools/me/edit_profile/add_password' : 'tools/login/account';
      default :
        return 'tools/me/edit_profile';
    }
  }
  
  //default popKey is 'logout'
  private getPopName(): string {
    switch (this.popKey) {
      case 'deleteAcct':
        return 'delect_account';
      case 'forgetPwd':
        return 'forget_password';
      default :
        return 'sign_out_account';
    }
  }
}